import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  /* property: {
    id: 11,
    name: 'East Hampton House',
    logo: 'https://s3.us-east-2.amazonaws.com/obmcontent.wavepm/obmproperties/east_hampton_house/EHHLogo4.png',
    tagLine: null,
    description:
      '<span style="color: rgb(32, 33, 36);">Step into serenity at the East Hampton House... Book your reservation today!</span>',
    footerImage: 'https://www.duneresorts.com/app/uploads/sites/2/2017/03/background-footer.jpg',
    heroImage:
      'https://www.duneresorts.com/app/uploads/sites/2/2019/09/ExteriorSign223-1800x1011.jpg',
    mapUrl:
      'https://www.google.com/maps/search/East+Hampton+House+East%20Hampton/@40.966980,%20-72.168797',
    mapImage: 'https://www.duneresorts.com/app/uploads/sites/2/2017/03/East-hampton-house-map.jpg',
    color: '#1a26d1',
    imageList: [
      {
        id: 34594831,
        url: 'https://www.duneresorts.com/app/uploads/sites/2/2019/09/EHHLobby_1s-1100x618.jpg',
      },
      {
        id: 34594830,
        url: 'https://www.duneresorts.com/app/uploads/sites/2/2021/08/DSC2913-1100x740.jpg',
      },
    ],
    roomImageList: [
      {
        id: 7147733,
        url: 'https://s3.us-east-2.amazonaws.com/obmcontent.wavepm/obmproperties/east_hampton_house/120/Room120_2.jpg',
      },
      {
        id: 7147729,
        url: 'https://s3.us-east-2.amazonaws.com/obmcontent.wavepm/obmproperties/east_hampton_house/112/112_BR2.jpg',
      },
      {
        id: 7147746,
        url: 'https://s3.us-east-2.amazonaws.com/obmcontent.wavepm/obmproperties/east_hampton_house/221/221_2.jpg',
      },
    ],
    attributeList: [
      {
        id: 34594837,
        title: 'BBQ AND PICNIC AREA',
      },
      {
        id: 34594838,
        title: 'FITNESS CENTER',
      },
      {
        id: 34594839,
        title: 'HEATED POOL',
      },
      {
        id: 34594840,
        title: 'TENNIS COURTS',
      },
      {
        id: 34594841,
        title: 'WALKING DISTANCE TO TOWN',
      },
    ],
    contact: {
      address: '226 Pantigo Road',
      city: 'East Hampton',
      phone: '1 (631) 324-4300',
    },
    companyAbout: null,
    companyInfo: '66 Newtown Lane, Suite 5, East Hampton New York 11937',
    companyLogo: null,
  }, */
  property: null,
};

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyProperty: (state, data) => {
      state.property = data.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCompanyProperty } = companySlice.actions;

export default companySlice.reducer;
